import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import * as _ from 'lodash';
import { takeUntil } from 'rxjs';
import { BaseComponent } from './../../../../core/components/base/base.component';
import { FeedbackService } from './../../../../core/services/feedback.service';
import { PatientService } from './../../../../core/services/patient.service';
import { RENDER_BATCH } from './../../../../shared/directives/render-more.directive';

@Component({
  selector: 'app-file-alert-list',
  templateUrl: './file-alert-list.component.html',
  styleUrls: ['./file-alert-list.component.scss']
})
export class FileAlertListComponent extends BaseComponent implements OnInit, OnChanges {
  /** Rows rendered so far; the rest render as the end of the list nears the screen. */
  shown = RENDER_BATCH;
  readonly renderBatch = RENDER_BATCH;
  @Input() filterValue: string = '';
  @Input() sortBy: 'surname' | 'firstName' | 'patientNumber' = 'surname';
  @Input() sortDirection: 'asc' | 'desc' = 'asc';
  filteredAlerts: any[] = [];
  allAlerts: any[] = [];



  constructor(private patientService: PatientService, fs: FeedbackService, md: MatDialog) {
    super(fs, md);
  }

  ngOnInit() {
    this.patientService.alerts$
      .pipe(
        takeUntil(this.destroy$)
      )
      .subscribe(alerts => {
        this.allAlerts = alerts || [];
        this.filteredAlerts = [...this.allAlerts];
        this.sortFileAlertsByName();
      });

  }


  ngOnChanges(changes: SimpleChanges) {
    if (changes['filterValue'] || changes['sortBy'] || changes['sortDirection']) {
      this.applyFilter();
    }
  }

  applyFilter() {
    this.shown = RENDER_BATCH;
    if (this.filterValue.trim() === '') {
      this.filteredAlerts = [...this.allAlerts];
    } else {
      const filterTerms = this.filterValue.toLowerCase().split(' ');
      this.filteredAlerts = this.allAlerts.filter(patient => {

        const icdCodesMatch = patient.icdCodes?.some((icdCode: any) =>
          filterTerms.every(term =>
            _.includes((icdCode.code || '').toLowerCase(), term) ||
            _.includes((icdCode.description || '').toLowerCase(), term)
          )
        );

        const patientMatch = filterTerms.every(term =>
          _.includes(patient.name.toLowerCase(), term) ||
          _.includes(patient.surname.toLowerCase(), term) ||
          _.includes(patient.patientNumber?.toLowerCase(), term) ||
          _.includes(patient.diagnosis?.toLowerCase(), term)
        );

        return icdCodesMatch || patientMatch;
      });
    }
    this.sortFileAlertsByName();
  }

  sortFileAlertsByName() {
    const prop = this.sortBy === 'firstName' ? 'name' : this.sortBy;
    const secondaryProp = prop === 'surname' ? 'name' : 'surname';
    const norm = (v: any) => (v == null ? '' : String(v)).trim().toLowerCase();
    this.filteredAlerts = _.orderBy(
      this.filteredAlerts,
      [(p: any) => norm(p[prop]), (p: any) => norm(p[secondaryProp])],
      [this.sortDirection, this.sortDirection]
    );
  }
}